import { useEffect } from "react";

interface SwipeTrackingProps {
  onSwipe: (direction?: "left" | "right") => void;
  selector: string;
}

function SwipeTracking({ onSwipe, selector }: SwipeTrackingProps) {
  useEffect(() => {
    if (!selector) {
      return;
    }

    const element = document.querySelector(selector);
    if (!element) {
      return;
    }

    let touchstartX = 0;
    let touchendX = 0;
    const minSwipeDistance = 50; // Minimum distance for swipe detection in pixels

    const handleTouchStart = (e: Event) => {
      touchstartX = (e as TouchEvent).changedTouches[0].screenX;
    };

    const handleTouchEnd = (e: Event) => {
      touchendX = (e as TouchEvent).changedTouches[0].screenX;
      handleGesture();
    };

    const handleGesture = () => {
      const swipeDistance = touchendX - touchstartX;

      if (Math.abs(swipeDistance) > minSwipeDistance) {
        if (touchendX < touchstartX) {
          onSwipe("left");
        } else if (touchendX > touchstartX) {
          onSwipe("right");
        }
      }
    };

    // Add event listeners
    element.addEventListener("touchstart", handleTouchStart);
    element.addEventListener("touchend", handleTouchEnd);

    // Cleanup event listeners on unmount
    return () => {
      element.removeEventListener("touchstart", handleTouchStart);
      element.removeEventListener("touchend", handleTouchEnd);
    };
  }, [onSwipe, selector]);

  return <></>;
}

export default SwipeTracking;
